import React, { useEffect } from 'react';
import { FlagsmithProvider } from 'flagsmith/react';
import flagsmith from 'flagsmith';
import config from '../config/index';
import { useUserInfo } from '../hooks/useUser';

const FlagsmithContainer = ({ children }) => {
  const user = useUserInfo();
  const { FLAGSMITH_ENV_ID } = config;

  useEffect(() => {
    const userEmail = user?.email;

    // identities are automatically created in flagsmith if one does not exist
    // we do not want unknown_email to be an identity
    if (userEmail) {
      flagsmith.identify(userEmail);
    }
  }, [user?.email]);

  const flagsmithOptions = {
    environmentID: FLAGSMITH_ENV_ID,
    cacheFlags: true,
    enableLogs: true,
    realtime: true,
  };

  return (
    <FlagsmithProvider flagsmith={flagsmith} options={{ ...flagsmithOptions }}>
      {children}
    </FlagsmithProvider>
  );
};

export default FlagsmithContainer;
